import { Helmet } from 'react-helmet-async';
import HeroSection from './components/HeroSection';
import FeaturedArticles from './components/FeaturedArticles';
import CategoryNav from './components/CategoryNav';
import LatestArticles from './components/LatestArticles';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'po文学指南',
    url: 'https://powenxue.com',
    description: '深度解析po文学的起源、特征与创作技巧。从入门到进阶，掌握碎片化叙事与情绪共鸣的核心方法。',
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: 'https://powenxue.com/search?q={search_term_string}',
      },
      'query-input': 'required name=search_term_string',
    },
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'po文学指南',
    url: 'https://powenxue.com',
    description: '专注于po文学创作技巧与行业趋势的综合性知识平台',
    sameAs: [
      'https://weibo.com/powenxue',
      'https://www.xiaohongshu.com/powenxue',
    ],
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: 'po文学是什么意思？和传统网络文学有什么不同？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'po文学是近年来兴起的一种新型网络文学形式，全称为"post文学"。与传统网络文学动辄数十万字的体量不同，po文学以短小精悍的篇幅、碎片化的叙事方式和强烈的情绪共鸣为核心特征。',
        },
      },
      {
        '@type': 'Question',
        name: '完全没有写作基础，可以学习po文学创作吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '当然可以！po文学的一个重要特点就是创作门槛低。因为它不要求构建复杂的情节线和人物关系，你可以从记录生活中的一个瞬间、一种情绪开始。',
        },
      },
      {
        '@type': 'Question',
        name: 'po文学有哪些主流的创作风格？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '目前po文学领域主要有四大风格流派：清冷文艺风、热烈叙事风、暗黑悬疑风和温暖治愈风。每种风格都有其独特的语言特征和情感基调。',
        },
      },
      {
        '@type': 'Question',
        name: '写po文需要多长时间？每天都要更新吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'po文学的篇幅通常较短，一篇作品的创作时间从几十分钟到几小时不等。建议新手从每周2-3篇开始，质量比数量更重要。',
        },
      },
      {
        '@type': 'Question',
        name: 'po文学作品可以在哪些平台发布？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '目前主流的po文发布平台包括小红书、微博超话、豆瓣小组和LOFTER等。不同平台的用户群体和内容偏好有所差异，建议新手从1-2个平台起步。',
        },
      },
      {
        '@type': 'Question',
        name: 'po文学能赚钱吗？有哪些变现方式？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '随着po文学的产业化发展，已经形成了多元化的变现模式，包括付费阅读、品牌合作、IP授权、线下活动和创作课程等。',
        },
      },
    ],
  };

  return (
    <>
      <Helmet>
        <title>po文学：网络创作新浪潮完全指南 - po文学指南</title>
        <meta name="description" content="深度解析po文学的起源、特征与创作技巧。po文学作为新兴网络文学形式，以碎片化叙事、情绪共鸣著称。本页汇聚po文学入门到进阶全攻略，助你快速掌握这一创作风格，写出刷屏爆款内容。" />
        <meta name="keywords" content="po文学,po文学创作技巧,po文学是什么,po文学入门教程,po文学写作风格,网络文学新形式,po文写法攻略" />
        <link rel="canonical" href="https://powenxue.com" />
        <meta property="og:title" content="po文学：网络创作新浪潮完全指南" />
        <meta property="og:description" content="深度解析po文学的起源、特征与创作技巧。po文学作为新兴网络文学形式，以碎片化叙事、情绪共鸣著称。入门到进阶全攻略。" />
        <meta property="og:url" content="https://powenxue.com" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="po文学：网络创作新浪潮完全指南" />
        <meta name="twitter:description" content="深度解析po文学的起源、特征与创作技巧。入门到进阶全攻略。" />
        <script type="application/ld+json">
          {JSON.stringify(websiteSchema)}
        </script>
        <script type="application/ld+json">
          {JSON.stringify(orgSchema)}
        </script>
        <script type="application/ld+json">
          {JSON.stringify(faqSchema)}
        </script>
      </Helmet>

      <HeroSection />
      <FeaturedArticles />
      <CategoryNav />
      <LatestArticles />
      <FAQSection />
      <CTASection />
    </>
  );
}